<ng-container *transloco="let t">
    <h2 mat-dialog-title>{{ t('SECURITY-NOTICE-TITLE') }}</h2>

    <mat-dialog-content>
        <!-- O.Plat_1: device protection -->
        <h3 class="mb-2 text-lg font-semibold">{{ t('SECURITY-NOTICE-DEVICE-HEADING') }}</h3>
        <p class="mb-3">{{ t('SECURITY-NOTICE-DEVICE-INTRO') }}</p>
        <p class="mb-3 font-semibold">{{ t('SECURITY-NOTICE-DEVICE-RISK') }}</p>
        <p class="mb-3">{{ t('SECURITY-NOTICE-DEVICE-ADVICE') }}</p>
        <p class="mb-6">{{ t('SECURITY-NOTICE-DEVICE-LOGOUT') }}</p>

        <!-- O.Plat_7: data can remain in the device's memory -->
        <h3 class="mb-2 text-lg font-semibold">{{ t('SECURITY-NOTICE-MEMORY-HEADING') }}</h3>
        <p class="mb-3">{{ t('SECURITY-NOTICE-MEMORY-INTRO') }}</p>
        <p class="mb-3 font-semibold">{{ t('SECURITY-NOTICE-MEMORY-RISK') }}</p>
        <p>{{ t('SECURITY-NOTICE-MEMORY-ADVICE') }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="showTips()">
            {{ t('SECURITY-NOTICE-MORE-TIPS') }}
        </button>
        <button mat-flat-button color="primary" type="button" [mat-dialog-close]="true">
            {{ t('SECURITY-NOTICE-CONFIRM') }}
        </button>
    </mat-dialog-actions>
</ng-container>
